module.exports = __webpack_public_path__ + "img/Elipse 52.5b4cb142.svg";